import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IGlobalSearchParam } from '../../../app/shared/models/Global-Search.model';
import { ApiService } from '../../shared/services';
import { ClientRequisitionContact } from '../models';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientRequisitionContactService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  getClientRequisitionContact(searchParam:IGlobalSearchParam):Observable<any>{
      return this.apiService.post(`ClientRequisitionContact/SearchClientRequisitionContact`,searchParam)
  }

  deleteClientRequisitionContact(id:number):Observable<any> {
    return this.apiService.delete(`ClientRequisitionContact/${id}`)
  }

  getClientCompanyList():Observable<any>{
    return this.apiService.get(`CompanyProfile/ClientCompanyList`);
  }

  postClientRequisitionContact(clientRequisitionContact: ClientRequisitionContact): Observable<any> {
    return this.apiService.post(`ClientRequisitionContact/PostClientRequisitionContact`, clientRequisitionContact)
  }

  public updateClientRequisitionContact(contactId:number, clientRequisitionContact:ClientRequisitionContact):Observable<any> {
    return this.apiService.put(`ClientRequisitionContact/${contactId}`, clientRequisitionContact)
    }

    public getClientRequisitionContactDetail(contactId:number):Observable<any> {
      return this.apiService.getInd(`ClientRequisitionContact/${contactId}`)
    }

    public onCrcAvailabilityCheck(companyId: number): Observable<any> {
      return this.apiService.get(`ClientRequisitionContact/CheckClientRequisitionContactExistById?companyId=${companyId}`);
    }

    public ExportClientRequisitionContact(clientRequisitionContactSearchParam:IGlobalSearchParam):Observable<any> {
      return this.http.post(`${environment.apiRoot}ClientRequisitionContact/ExportClientRequisitionContact`, clientRequisitionContactSearchParam,
      {  
          responseType: 'blob',
          observe: 'response'
       });
    }

}
